/* LAYOUT */
export const CALL_DATA = "CALL_DATA";
export const UPDATE_DATA = "UPDATE_DATA";
export const UPDATE_USER = "UPDATE_USER";
